<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>课程中心</span><span>/</span><span>已购课程</span></div>
    <div class="disFlex between curse-search">
      <div>
        <el-input v-model="formInline.keyword" placeholder="请输入名称查询" suffix-icon="el-icon-search" clearable></el-input>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.itype" placeholder="全部培训类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline.isgq" placeholder="请选择状态" clearable>
              <el-option label="正常" value="1"></el-option>
              <el-option label="已过期" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading">
      <div class="disFlex" style="flex-wrap:wrap;" v-if="tableData.rows.length>0">
        <div class="curseInfoBlock" v-for="(item,k) in tableData.rows"
          :style="k>0&&k%4==3&&!collapse?'margin-right:0;':''">
          <div :class="'disFlex between curseevery-top'+(item.state=='3'?'ygq':'')" @click="toProductXq(item.id)">
            <el-image style="width: 256px; height: 152px;border-radius: 6px 6px 0 0;cursor: pointer;"
              :src="wjSrc+item.img"></el-image>
          </div>
          <div class="disFlex between curseevery-center">
            <div class="curseevery-title ellipsis">{{item.cname}}</div>
          </div>
          <div class="disFlex curseevery-bot">
            <div class="flex1" @click="toDetail(item.id)">
              <img src="@/assets/images/icons/view.png" />
              查看
            </div>
            |
            <div class="flex1" @click="showBm(item)">
              <img src="@/assets/images/icons/bmicon.png" style="margin-top: -2px;" />
              报名管理
            </div>
            |
            <div class="flex1" @click="toPgbg(item.id,item.ontype)">
              <i class="el-icon-s-marketing"></i>
              评估报告
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>

    <el-pagination background :hide-on-single-page="true" style="margin-top: 10px;text-align: right;"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
      :page-sizes="[10, 20, 50, 100]" :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.total">
    </el-pagination>

    <el-dialog title="批量报名" :visible.sync="dialogVisible" width="1200px" :append-to-body="true"
      :destroy-on-close="true">
      <baoming-list flag="1" :selectUserIds="selectUserIds" :isck="allBuyMount==bmparams.isUser.length"
        @changeBb="changeBb" :wjSrc="wjSrc" :appUsers="oldUser" :currentUser="currentUser" :activeObj="activeObj" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave()" v-if="allBuyMount>bmparams.isUser.length">确认报名</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          keyword: '',
          isgq: '',
          page: 1,
          rows: 10,
          flag: '2',
          cid: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        dialogVisible: false,
        selectUserIds: [],
        selectIdArr: [],
        selectRows: [],
        bmparams: {
          isUser: []
        },
        loading: true,
        allBuyMount: 0,
        oldUser: [],
        isck: false,
        activeObj: ''
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        var params = this.formInline;
        params.own = this.currentUser.id;
        this.$axios.get('/kt/productInfo/get2listPage.htm?' + this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/curseInfo');
      },
      toDetail: function(id) {
        this.$router.push('/Company/CurseInfo?id=' + id);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showBm: function(item) {
        var {
          id,
          name,
          itype,
          cid,
          isUser,
          buyamount,
          buyid,
          endtime
        } = item;
        var name = item.cname,
          itype = item.ontype,
          isUser = item.appUsers,
          buyamount = item.dnbuyamount;
        this.activeObj = item;
        var bmshowparam = {
          productid: id,
          cid: this.currentUser.cid
        };
        this.$axios.get('/kt/ktProductAppy/getlist.htm?' + this.$qs.stringify(bmshowparam)).then(res => {
          var data = res.data;
          if (data) {
            isUser = data;
            this.oldUser = isUser;
            this.allBuyMount = isUser.length + buyamount;
            this.bmparams = {
              productname: name,
              productid: id,
              itype: itype,
              cid: cid,
              buyamount: buyamount,
              isUser: isUser,
              buyid: buyid,
              endtime: endtime
            };
            var selectUserIds = [];
            isUser.map((item) => {
              selectUserIds.push(item.appyuserid);
            });
            this.selectUserIds = selectUserIds;
            this.dialogVisible = true;
          } else {
            this.$message.error(data.message);
          }
        })
        return;

      },
      changeBb: function(selectIdArr, selectRows) {
        if (selectIdArr.length > this.allBuyMount) {
          this.selectIdArr = selectIdArr.splice(0, this.allBuyMount);
          this.selectRows = selectRows.splice(0, this.allBuyMount);
          this.selectUserIds = this.selectIdArr;
          this.$message.warning('该课程你购买的数量为' + this.allBuyMount + '，所以只能选择' + this.allBuyMount + '个学员！')
        } else {
          this.selectIdArr = selectIdArr;
          this.selectRows = selectRows;
        }
      },
      handleAave: function() {
        var isUser = [];
        var $this = this;
        // 最新的取证培训
        var isNewqz = false;
        if (this.activeObj.ontype.indexOf('ZXKT_producttype_2_6') >= 0) {
          isNewqz = true;
        }
        this.selectRows.map((item, i) => {
          if (!this.oldHas(item.id)) {
            var obj = {
              appyuserid: item.id,
              appyusername: item.realName,
              peixunitype: item.peixunitype, //初次/再次教育
              zgtype: item.zgtype, //主要负责人管理人
            };
            // 最新的取证培训
            if (isNewqz) {
              if (this.activeObj.productPxxz == 1) {
                obj.zgtype = 1
                obj.peixunitype = 1;
              }
              if (this.activeObj.productPxxz == 2) {
                obj.zgtype = 1
                obj.peixunitype = 2;
              }
              if (this.activeObj.productPxxz == 3) {
                obj.zgtype = 2
                obj.peixunitype = 1;
              }
              if (this.activeObj.productPxxz == 4) {
                obj.zgtype = 2
                obj.peixunitype = 2;
              }
            }
            console.log(obj)
            isUser.push(obj)
          }
        });
        this.$set(this.bmparams, 'isUser', JSON.stringify(isUser))
        this.$axios.post('/kt/ktProductAppy/allocation.htm', this.$qs.stringify(this.bmparams)).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message({
              message: data.message,
              type: 'success'
            });
            $this.getcurseList();
          } else {
            this.$message.error(data.message);
          }
          this.dialogVisible = false;
        })
      },
      // 判断是新加的人  还是原来就有的人
      oldHas: function(id) {
        var obj = null;
        var isflag = false;
        this.oldUser.map((item) => {
          if (item.appyuserid == id) {
            isflag = true;
          }
        });
        return isflag;
      },
      // 跳转产品详情
      toProductXq: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      },
      // 评估报告查看
      toPgbg(id) {
        this.$router.push('/Company/Pxbaogao?id=' + id + '&flag=2');
      }
    },
    created: function() {
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));
      this.$set(this.formInline, 'cid', this.currentUser.cid);
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1)
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;
    text-align: center;

  }

  .curseevery-bot img {
    margin-right: 6px;

  }
</style>



// WEBPACK FOOTER //
// src/components/company/BuyCurriculum.vue